import script from "./MetaContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./MetaContainer.vue?vue&type=script&setup=true&lang=js"

import "./MetaContainer.vue?vue&type=style&index=0&id=64cae0e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64cae0e4"]])

export default __exports__